// extracted by mini-css-extract-plugin
export default {"title":"project-view_title__Bm331","error":"project-view_error__LiN-A","tabsWrap":"project-view_tabsWrap__engER"};